import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {EventDraftSavedPanelProps} from '@Panels/event-draft-saved-panel/event-draft-saved-panel.types';

export const openEventDraftSavedModal = (props: EventDraftSavedPanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EVENT_DRAFT_SAVED_MODAL,
      panelProps: props,
    })
  );
};
